<script>
import axios from "axios";
import * as Sentry from "@sentry/browser";

const MAX_TRIES = 2;

export default {
  data() {
    return {
      genePanelsList: null,
      genePanelsOptionsValueObj: {},
      debounceDelay: 300,
      typingTimeout: null,
      isSearchingGenePanels: null,
      genePanelsSearchMsg: "Start typing for finding results",
      foundGenePanelsData: false,
      brokenGenePanelsApi: false,
    };
  },
  methods: {
    handleGenePanelsSearchChange(searchQuery) {
      if (!searchQuery) {
        return;
      }

      // Clear the previous timer
      clearTimeout(this.typingTimeout);

      // Set a new timer to call the API after debounceDelay milliseconds
      this.typingTimeout = setTimeout(async () => {
        this.isSearchingGenePanels = true;

        let res;

        try {
          res = await this.retrieveGenePanelsList(searchQuery);
        } catch (error) {
          console.error(
            "Caught error when calling retrieveGenePanelsList",
            error
          );

          Sentry.captureException(
            `Caught error when calling retrieveGenePanelsList: ${error}`
          );
        }

        this.isSearchingGenePanels = false;

        if (!res) {
          this.brokenGenePanelsApi = true;

          this.$set(this, "genePanelsList", []);
          this.$set(this, "foundGenePanelsData", false);
          this.$set(this, "genePanels", []);
          return;
        }

        const data = res.data;
        if (data) {
          if (data.length === 0) {
            this.foundGenePanelsData = false;
            this.genePanelsSearchMsg = "No results found";
          } else {
            this.foundGenePanelsData = true;

            let genePanelsOption = [];

            data.forEach((panel) => {
              const panelName = panel.attributes.panelName;

              // Adding a new key-value pair reactively for data in Vue2
              this.$set(
                this.genePanelsOptionsValueObj,
                panelName,
                panel.attributes.panelId
              );

              genePanelsOption = [...genePanelsOption, `${panelName}`];
            });

            // Add selected genes in genePanelsList to make use of built-in <auto-complete> UI feature
            this.genePanelsList = [...genePanelsOption, ...this.genePanels];
          }
        }
      }, this.debounceDelay);
    },
    async retrieveGenePanelsList(searchQuery) {
      let res = null;

      // Try API call twice before displaying Alert on the screen
      for (let i = 1; i <= MAX_TRIES; i++) {
        try {
          res = await this.callGenePanelsApi(searchQuery);

          if (res && res.status === 200) return res.data;
        } catch (error) {
          console.error("Caught error when calling callGenePanelsApi", error);
        }
      }
    },
    async callGenePanelsApi(searchQuery) {
      const genePanelsSearchEndpoint = `${this.$dataset.externalCms}/api/panel-app-gene-panels?filters[$or][0][panelId][$containsi]=${searchQuery}&filters[$or][1][panelName][$containsi]=${searchQuery}`;

      try {
        return await axios.get(genePanelsSearchEndpoint);
      } catch (error) {
        console.error(
          `Caught error when making API call to ${genePanelsSearchEndpoint}:`,
          error
        );
      }
    },
    filterGenePanelsItems(item, queryText, itemText) {
      // Overwrite default `filter` props for v-autocomplete to display results that does not contain search query input string
      // For more: https:github.com/vuetifyjs/vuetify/blob/v2-stable/packages/vuetify/src/components/VAutocomplete/VAutocomplete.ts#L40

      return queryText && this.foundGenePanelsData;
    },
    // Convert gene panels value to the form of "<panelId> - <panelName>|<panelId> - <panelName>|..."
    getFinalGenePanels(genePanelsArr) {
      return genePanelsArr
        .map(
          (panelName) =>
            this.genePanelsOptionsValueObj[`${panelName}`] + " - " + panelName
        )
        .join("|");
    },
    // Used for display gene panels value in Summary screen for prenatal test(s)
    displayPrenatalGenePanels(pipedVal) {
      return pipedVal.replace(/\|/g, ", ");
    },
  },
};
</script>
